import { render, staticRenderFns } from "./TableStyleComponentTotal.vue?vue&type=template&id=105e1c3e&scoped=true"
import script from "./TableStyleComponentTotal.vue?vue&type=script&lang=js"
export * from "./TableStyleComponentTotal.vue?vue&type=script&lang=js"
import style0 from "./TableStyleComponentTotal.vue?vue&type=style&index=0&id=105e1c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e1c3e",
  null
  
)

export default component.exports